export const masterFirebaseConfig = {
    apiKey: "AIzaSyBwM_cV0ALhK6I2ROk0o71kOd7LXaZQy5w",
    authDomain: "mock-mint.firebaseapp.com",
    databaseURL: "https://mock-mint.firebaseio.com",
    projectId: "mock-mint",
    storageBucket: "mock-mint.appspot.com",
    messagingSenderId: "408564943513"
  };
  


// WEBPACK FOOTER //
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/api-keys.ts